<template>
    <div>

      <div class="table_card">
        <div class="table_card__head">
          <p class="table_card__head--title">
            Búsqueda de Usuario
          </p>
        </div>
        <div class="table_card__body">
          <v-flex xs12 row>
            <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap >
                <v-flex xs6 >
                  <!--<v-text-field
                    label="Ingrese la cédula del usuario:"
                    v-model="searching_rut"
                    required
                    :rules="[rules.required]"
                    oninput="this.value = this.value.toUpperCase()"
                    counter="10">
                  </v-text-field>-->
                  <input
                    v-model="searching_rut"
                    placeholder="Ingrese el documento del usuario"
                    required
                    class="input_solid"
                    style="width: 98% !important"
                  >
                  <img
                    src="@/assets/img/icons/search-icon.svg"
                    class="button_search"
                    style="margin-left: -55px"
                  >
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <button
                    type="button"
                    class="faccess_button"
                    @click="getUserData()"
                    :disabled="!valid || searching_rut == '' || searching_rut.length > 10"
                  >Consultar</button>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </div>
        <div v-if="user_finded" class="table_card__body pt-0">
          <v-layout row>
            <p class="accessIndex__text--title">Información Usuario</p>
          </v-layout>
          <v-layout row wrap >
            <v-flex xs12 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap
                  style="background-color: #fff; padding: 0px;">
                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Nombre:"
                    v-model="user.user_info_attributes.name"
                    :readonly="true"
                    required
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Apellido:"
                    v-model="user.user_info_attributes.last_name"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Cédula:"
                    v-model="user.rut"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Correo:"
                    v-model="user.email"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Plan desde:"
                    v-model="user.user_info_attributes.plan_from"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Plan hasta:"
                    v-model="user.user_info_attributes.plan_until"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Tipo de membresía:"
                    v-model="user.user_info_attributes.membership_type"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Tipo de plan:"
                    v-model="user.user_info_attributes.plan_type"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Tipo de usuario:"
                    v-model="user.user_info_type"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Estado:"
                    v-model="user.user_info_attributes.access_state"
                    :readonly="true"
                    required>
                  </v-text-field>
                </v-flex>

              </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="user_finded" class="table_card__footer">
          <button
            type="button"
            @click="$emit('selected', {user_company: user.user_company})"
            :disabled="user.user_info_attributes.access_state != 'Activo'"
            class="faccess_button"
          >
            Crear reserva
          </button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
      return{
          searching_rut: '',
          user: {
              email: '',
              rut: '',
              user_company: '',
              user_info_type: '',
              user_info_attributes:{
                  name: "",
                  last_name: "",
                  plan_from: "",
                  plan_until: "",
                  plan_type: "",
                  membership_type: "",
                  access_state: ""
              }
          },
          rules: {
              required: value => !!value || 'Required.'
          },
          user_finded: false,
          valid: false
      }
  },
  methods:{
    getUserData(){
      var params = this.$route.params;
      try {
        this.$http.get('app/users/find_user_by_rut', {
          headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
          },
          params:{
              rut: this.searching_rut,
              company_id: this.getCompany().id
          }
        }).then(function(response){
          if(response.body != null){
            var data = response.body
            this.user.user_info_attributes.name = data.user_info.name
            this.user.user_info_attributes.last_name = data.user_info.last_name
            this.user.rut = data.user.rut
            this.user.email = data.user.email
            this.user.user_company = data.user.user_company
            this.user.user_info_attributes.plan_from = data.user_info.plan_from
            this.user.user_info_attributes.plan_until = data.user_info.plan_until
            this.user.user_info_attributes.plan_type = data.user_info.plan_type
            this.user.user_info_attributes.membership_type = data.user_info.membership_type
            this.user.user_info_attributes.access_state = data.user_info.access_state == "GRANTED" ? "Activo" : "Inactivo"
            this.user.user_info_type = data.user.user_info_type
            this.user_finded = true
          }else{
            this.user_finded = false
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true);
          }
        }, function(response){
          // this.updateAlertMessage("No te hemos encontrado en los registros de sportlife", "Lo sentimos")
          this.user.user_info_attributes.name = ''
          this.user.user_info_attributes.last_name = ''
          this.user.rut = ''
          this.user.email = ''
          this.user.user_info_attributes.plan_from = ''
          this.user.user_info_attributes.plan_until = ''
          this.user.user_info_attributes.plan_type = ''
          this.user.user_info_attributes.membership_type = ''
          this.user.user_info_attributes.access_state = ''
          this.user.user_info_type = ''
          this.user_finded = false
          this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
          this.updateIsInAlert(true);
        })
      } catch (e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true);
      }
    },
  }, /* closed methods */
}
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/UserBooking.vue